const contentDialog = document.querySelector('#content-dialog');
const cartDialog = document.querySelector('#cart-dialog');
const dialogBody = document.querySelector('#dialog-body');
const LW = window.LW || { assets: {} };
const img = name => LW.assets[name] || '';
const money = cents => new Intl.NumberFormat('en-ZA', { style: 'currency', currency: 'ZAR', maximumFractionDigits: 0 }).format(cents / 100);
const escapeHtml = text => String(text).replace(/[&<>"]/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[char]));

document.querySelector('.scroll-invitation')?.addEventListener('click', event => {
  if (!CSS.supports('(animation-timeline: view()) and (animation-range: 0% 100%) and (timeline-scope: --book-journey)') || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  event.preventDefault();
  const journey = document.querySelector('.book-journey');
  window.scrollTo({ top: journey.offsetTop + (journey.offsetHeight - innerHeight) * .25, behavior: 'smooth' });
});

function openContent(html, label) {
  dialogBody.innerHTML = html;
  contentDialog.setAttribute('aria-label', label);
  contentDialog.showModal();
  contentDialog.scrollTop = 0;
}

document.querySelectorAll('.dialog-close').forEach(button => button.addEventListener('click', () => button.closest('dialog').close()));
document.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('click', event => {
  if (event.target !== dialog) return;
  const rect = dialog.getBoundingClientRect();
  if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
}));

const menuButton = document.querySelector('#menu-button');
menuButton.addEventListener('click', () => {
  const open = menuButton.getAttribute('aria-expanded') !== 'true';
  menuButton.setAttribute('aria-expanded', String(open));
  menuButton.setAttribute('aria-label', open ? 'Maak kieslys toe' : 'Maak kieslys oop');
  document.querySelector('.header nav').classList.toggle('open', open);
});
document.querySelectorAll('.header nav a').forEach(link => link.addEventListener('click', () => {
  menuButton.setAttribute('aria-expanded', 'false');
  menuButton.setAttribute('aria-label', 'Maak kieslys oop');
  document.querySelector('.header nav').classList.remove('open');
}));

const searchBox = document.querySelector('#recipe-search');
function applyRecipeFilters() {
  const active = document.querySelector('[data-filter].active')?.dataset.filter || 'all';
  const words = (searchBox?.value || '').toLowerCase().split(/\s+/).filter(Boolean);
  const rows = document.querySelectorAll('[data-row]');
  let shown = 0;
  document.querySelectorAll('[data-category]').forEach(card => {
    const row = card.closest('[data-row]');
    const tagMatch = row ? active === 'all' || row.id === 'kat-' + active : active === 'all' || (card.dataset.tags || '').split(' ').includes(active);
    const textMatch = words.every(word => (card.dataset.search || '').includes(word));
    card.hidden = !(tagMatch && textMatch);
    if (!card.hidden) shown++;
  });
  rows.forEach(row => { row.hidden = !row.querySelector('[data-category]:not([hidden])'); });
  const empty = document.querySelector('#search-empty');
  if (empty) empty.hidden = shown > 0;
}
document.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => {
  document.querySelectorAll('[data-filter]').forEach(filter => {
    filter.classList.toggle('active', filter === button);
    filter.setAttribute('aria-pressed', String(filter === button));
  });
  applyRecipeFilters();
}));
searchBox?.addEventListener('input', applyRecipeFilters);
document.querySelectorAll('[data-row]').forEach(row => {
  const track = row.querySelector('.carousel');
  const step = direction => track.scrollBy({ left: direction * track.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  row.querySelector('.cat-prev')?.addEventListener('click', () => step(-1));
  row.querySelector('.cat-next')?.addEventListener('click', () => step(1));
});

/* Cart: Shopify's Ajax cart. Checkout happens on Shopify's own secure checkout. */
let cart = { item_count: 0, items: [], total_price: 0 };
const cartHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };

async function refreshCart() {
  try {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    cart = await response.json();
  } catch { /* offline: keep the last known cart */ }
  renderCart();
}
async function addToCart(id) {
  await fetch('/cart/add.js', { method: 'POST', headers: cartHeaders, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) });
  await refreshCart();
}
async function changeLine(key, quantity) {
  const response = await fetch('/cart/change.js', { method: 'POST', headers: cartHeaders, body: JSON.stringify({ id: key, quantity }) });
  if (response.ok) cart = await response.json();
  renderCart();
}

function renderCart() {
  document.querySelector('#cart-count').textContent = cart.item_count;
  document.querySelectorAll('.tab-count').forEach(badge => { badge.textContent = cart.item_count; badge.hidden = !cart.item_count; });
  const hasBook = cart.items.some(item => item.variant_id === LW.book);
  const hasDigital = cart.items.some(item => item.variant_id === LW.digital);
  const upsell = hasBook && !hasDigital && LW.digital ? `<div class="cart-upsell"><span>Voeg die e-boek by · ${money(LW.digitalPrice)}</span><button type="button" data-upsell>Voeg by</button></div>` : '';
  document.querySelector('#cart-body').innerHTML = cart.item_count ? `
    <ul class="cart-items">${cart.items.map(item => `
      <li class="cart-product">${item.image ? `<img src="${escapeHtml(item.image)}" alt="" width="80" height="100">` : ''}
        <div><h3>${escapeHtml(item.product_title)}</h3>${item.variant_title ? `<p>${escapeHtml(item.variant_title)}</p>` : ''}<p>${money(item.final_price)}</p>
          <div class="qty-row"><button type="button" data-line="${item.key}" data-qty="${item.quantity - 1}" aria-label="Minder">−</button><span aria-live="polite">${item.quantity}</span><button type="button" data-line="${item.key}" data-qty="${item.quantity + 1}" aria-label="Meer">+</button>
          <button class="remove-item" type="button" data-line="${item.key}" data-qty="0">Verwyder</button></div></div></li>`).join('')}</ul>
    <div class="cart-total"><span>Subtotaal</span><strong>${money(cart.total_price)}</strong></div>
    ${upsell}<p class="purchase-note">${escapeHtml(LW.delivery || 'Aflewering word by die betaalpunt bereken.')}</p>
    <a class="button" href="/checkout">Gaan betaal <span>↗</span></a>
    <button class="text-link" id="continue-browsing" type="button">Kuier nog ’n bietjie ↗</button>` : `
    <p>Jou mandjie is nog leeg. Daar’s ’n stukkie Weskus wat vir jou wag.</p><a class="button" href="${LW.bookUrl || '/'}">Kry die boek <span>↗</span></a>`;
  document.querySelectorAll('#cart-body [data-line]').forEach(button => button.addEventListener('click', () => changeLine(button.dataset.line, Number(button.dataset.qty))));
  document.querySelector('[data-upsell]')?.addEventListener('click', () => addToCart(LW.digital));
  document.querySelector('#continue-browsing')?.addEventListener('click', () => cartDialog.close());
}

document.querySelectorAll('[data-buy]').forEach(button => button.addEventListener('click', async () => {
  const form = button.closest('[data-product-form]');
  const variant = form ? form.querySelector('[name=id]').value : LW.book;
  button.disabled = true;
  await addToCart(variant);
  button.disabled = false;
  cartDialog.setAttribute('aria-label', 'Jou mandjie');
  cartDialog.showModal();
}));
document.querySelectorAll('[data-cart]').forEach(button => button.addEventListener('click', async () => { await refreshCart(); cartDialog.showModal(); }));

document.querySelectorAll('[data-preview]').forEach(button => button.addEventListener('click', () => {
  openContent(`<div class="eyebrow">’N KLEIN VOORSMAKIE</div><h2>Blaai ’n bietjie <em>saam.</em></h2><p>Werklike bladsye uit die boek: die inhoud, ’n resep en ’n kuskuier.</p><div class="preview-grid"><figure><img src="${img('preview-contents.jpg')}" alt="Die boek se inhoudsopgawe"><figcaption>Wat wag binne</figcaption></figure><figure><img src="${img('preview-recipe.jpg')}" alt="Snoekbraai-resep uit die boek"><figcaption>By die vuur</figcaption></figure><figure><img src="${img('preview-town.jpg')}" alt="Velddrif-fotoblad uit die boek"><figcaption>Langs die kus</figcaption></figure></div>`, 'Loer binne die boek');
}));

const stories = {
  velddrif: { title: 'Waar die rivier die kus ontmoet.', place: 'VELDDRIF', image: 'velddrif.webp', text: 'Soutpanne, flaminke en die Bergrivier. Velddrif loop soos ’n draad deur die verhaal van Lekker Weskus. Dawid en Georgia het in April 2022 hierheen getrek; die dorp en sy geure het deel van hul daaglikse lewe geword.', outro: 'Die plekke en mense is net so deel van die boek soos die kos.' },
  paternoster: { title: 'Paternoster, stadig asseblief.', place: 'PATERNOSTER', image: 'paternoster.webp', text: 'Wit huise, ’n oop horison en kos wat na die see smaak. Die boek bring Paternoster se kuslewe en seekos bymekaar, met onder meer ’n besoek aan Wolfgat.', outro: 'Vir ’n rustige leesstonde en jou volgende kuier.' },
  lamberts: { title: '’n Draai in Lambertsbaai.', place: 'LAMBERTSBAAI', image: 'coast.webp', text: 'In die boek vertel Dawid van sy eerste besoek aan Muisbosskerm in 2007, en die kuiers wat later gevolg het. Lambertsbaai se hawe, visserbote en seekos gee die dorp sy eie plek in die Lekker Weskus-verhaal.', outro: 'Hier ontmoet reisstories en resepte mekaar. Van die hawe af terug na die vuur.' }
};
document.querySelectorAll('[data-story]').forEach(button => button.addEventListener('click', () => {
  const story = stories[button.dataset.story];
  openContent(`<div class="eyebrow">KUSSTORIES / ${story.place}</div><h2>${story.title}</h2><img class="dialog-photo" src="${img(story.image)}" alt="${story.place}"><p>${story.text}</p><p>${story.outro}</p>`, story.title);
}));

const buyBar = document.querySelector('.mb-bar');
const heroBuy = document.querySelector('.mb-buy');
if (buyBar && heroBuy && 'IntersectionObserver' in window) {
  new IntersectionObserver(([entry]) => buyBar.classList.toggle('show', !entry.isIntersecting && entry.boundingClientRect.top < 0), { threshold: 0 }).observe(heroBuy);
} else buyBar?.classList.add('show');

refreshCart();
